<template>
  <div class="panel" :class="{ collapsed: isCollapsed, collapsible: collapsible }">
    <div class="panel--inner">
      <div class="title" v-if="showTitle" :class="{ pointer: collapsible }" @click="toggleCollapse()">
        <tag large v-show="!!tag">{{ tag }}</tag>
        <span class="prefix" v-if="prefix">{{ prefix }}</span>
        <svgicon class="icon" v-if="icon" :src="icon" :height="16" :width="16"></svgicon>
        <span class="title__text">{{title}}</span>
        <svgicon v-if="collapsible" src="/icon/arrow.svg" class="titleChevron" :class="{ collapsed: isCollapsed }"
          :width="16"></svgicon>
      </div>
      <label class="subTitle">
        {{ subTitle }}
      </label>
      <div class="content">
        <div class="content-inner" :class="{ 'no-padding': !showTitle }">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {

    name: "Panel",

    props: {
      collapsible: Boolean,
      title: String,
      subTitle: String,
      icon: String,
      collapsed: Boolean,
      tag: String,
      prefix: String,
      showTitle: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        isCollapsed: this.collapsed
      }
    },

    methods: {
      toggleCollapse() {
        if (this.collapsible) {
          this.isCollapsed = !this.isCollapsed;
          if (!this.isCollapsed) {
            this.$emit("opened");
          }
        }
      },
      close() {
        this.isCollapsed = true;
      },
      open() {
        this.isCollapsed = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .panel {
    background-color: white;
    border-radius: 24px;
    padding: 30px 40px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.1);

    .panel {
      padding: 20px 0 0 0;
      box-shadow: none;
      border-radius: 0;

      & > .panel--inner > .title {
        font-weight: bold;
        font-size: 16px;
        color: var(--primary-color);
        padding-bottom: 10px;
        border-bottom: 1px solid #e5e5e5;
        position: relative;

        .svgicon.icon {
          fill: var(--primary-color);
        }
      }

      .panel {
        padding: 10px 0 0 20px;

        & > .panel--inner > .title {
          color: #b8b8b8;
          font-weight: 500;
        }
      }
    }

    & > .panel--inner > .title {
      font-weight: bold;
      font-size: 16px;
      line-height: 1;
      position: relative;
      user-select: none;
      display: flex;
      align-items: center;

      .tag {
        margin-right: 10px;
        line-height: initial;
      }
    }

    .subTitle {
      margin-top: 4px;
    }

    .prefix {
      padding-right: 5px;
    }

    .content {
      display: flex;
      flex-direction: column;
      max-height: 100%;
    }

    .content-inner {
      display: flex;
      flex-direction: column;
      max-height: 100%;
    }

    .content-inner:not(.no-padding) {
      padding-top: 30px;
    }

    .actions {
      margin-top: 30px;
    }

    .pointer {
      cursor: pointer;
    }

    &.collapsible {

      .titleChevron {
        fill: #d9d9d9;
        position: absolute;
        right: 0;
        top: 4px;
        transition: transform 0.3s ease-in-out;
        transform: rotateZ(180deg);
      }

      &.collapsed {
        .titleChevron {
          transform: none;
        }

        .content {
          opacity: 0;
          max-height: 0;
          padding: 0;
          visibility: collapse;
          overflow: hidden;
        }
      }

      .content {
        transition: max-height 0.2s, opacity 0.2s, visibility 0.2s;
      }
    }
  }

  @media (max-width: 767px) {
    .panel {
      padding: 20px 10px;

      & > .panel--inner > .title {
        font-size: 18px;
      }
    }
  }
</style>

<style lang="scss">
  .panel .subtitle-2 {
    font-weight: bold;
    font-size: 16px;
    color: var(--secondary-color);
    margin-bottom: 20px;
    line-height: 1;
  }

  .panel .subtitle {
    font-weight: bold;
    font-size: 16px;
    color: var(--primary-color);
    margin-bottom: 20px;
    line-height: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:not(:first-child) {
      margin-top: 10px;
    }
  }

  .panel .collapsed .content {
    * {
      height: 0;
      padding: 0;
    }
  }
</style>